import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../App.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const result = await login(email, password);

        if (result.success) {
            const roleName = result.user.role_details?.name;
            if (roleName === 'SUPER_ADMIN' || result.user.is_superuser) {
                navigate('/');
            } else {
                navigate('/fast-food/pos');
            }
        } else {
            setError(result.error);
        }
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', width: '100vw', margin: 0, padding: 0 }}>
            <style>
                {`
                @media (max-width: 768px) {
                    .login-image-side { display: none !important; }
                    .login-form-side { width: 100% !important; flex: none !important; }
                }
                .elegant-input {
                    width: 100%;
                    padding: 16px 20px;
                    border-radius: 16px;
                    border: 1.5px solid #e8ded1;
                    font-size: 1rem;
                    background-color: #fdfbf8;
                    transition: all 0.3s ease;
                    outline: none;
                    box-sizing: border-box;
                }
                .elegant-input:focus {
                    border-color: var(--primary-color);
                    background-color: #ffffff;
                    box-shadow: 0 0 0 4px rgba(96, 56, 51, 0.15);
                }
                .elegant-btn {
                    width: 100%;
                    padding: 16px;
                    font-size: 1.15rem;
                    font-weight: 700;
                    border-radius: 16px;
                    background-color: var(--primary-color);
                    color: #fff;
                    border: none;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 8px 20px rgba(96, 56, 51, 0.25);
                }
                .elegant-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 25px rgba(96, 56, 51, 0.35);
                    background-color: var(--primary-hover, #482622);
                }
                `}
            </style>
            
            {/* Lado de la Imagen */}
            <div 
                className="login-image-side"
                style={{ 
                    flex: 1, 
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#1e0e0c'
                }}
            >
                {/* Fondo Desenfoque (Blur) para auto-rellenar */}
                <div 
                    style={{
                        position: 'absolute',
                        top: '-30px',
                        left: '-30px',
                        right: '-30px',
                        bottom: '-30px',
                        backgroundImage: `url(${require('../../assets/fotoparalogin.png')})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(28px) brightness(0.65)',
                        transform: 'scale(1.15)',
                        zIndex: 1
                    }}
                />

                {/* Tinte degradado elegante */}
                <div 
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'radial-gradient(circle at center, rgba(96, 56, 51, 0.2) 0%, rgba(30, 14, 12, 0.55) 100%)',
                        zIndex: 2
                    }}
                />

                {/* Contenedor de la Imagen Completa */}
                <div 
                    style={{
                        position: 'relative',
                        zIndex: 3,
                        width: '92%',
                        maxWidth: '680px',
                        padding: '1.5rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <img 
                        src={require('../../assets/fotoparalogin.png')} 
                        alt="TioNel"
                        style={{
                            width: '100%',
                            maxHeight: '85vh',
                            objectFit: 'contain',
                            borderRadius: '20px',
                            boxShadow: '0 20px 45px rgba(0, 0, 0, 0.45)',
                            border: '1px solid rgba(255, 255, 255, 0.12)'
                        }}
                    />
                </div>
            </div>

            {/* Lado del Formulario */}
            <div 
                className="login-form-side"
                style={{ 
                    flex: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    backgroundColor: 'var(--sidebar-bg)', // Fondo crema
                    padding: '2rem'
                }}
            >
                <div style={{ 
                    width: '100%', 
                    maxWidth: '540px', 
                    textAlign: 'center', 
                    backgroundColor: '#ffffff',
                    boxShadow: '0 25px 50px -12px rgba(96, 56, 51, 0.15)', 
                    padding: '4.5rem 4rem', 
                    borderRadius: '24px' 
                }}>
                    <img src={require('../../assets/logo.png')} alt="TioNel" style={{ height: '160px', marginBottom: '20px', objectFit: 'contain' }} />
                    <h2 style={{ color: 'var(--primary-color)', fontSize: '2.5rem', fontWeight: '800', marginBottom: '8px', letterSpacing: '-0.5px' }}>Iniciar Sesión</h2>
                    <p style={{ marginBottom: '40px', color: '#666', fontSize: '1.2rem', fontWeight: '500' }}>Bienvenido al portal de TioNel</p>

                    {error && <div className="alert alert-error" style={{ marginBottom: '25px', borderRadius: '12px', padding: '15px', backgroundColor: '#fee2e2', color: '#991b1b', border: '1px solid #f87171' }}>{error}</div>}

                    <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
                        <div className="form-group" style={{ marginBottom: '25px' }}>
                            <label htmlFor="email" style={{ fontWeight: '700', color: 'var(--primary-color)', marginBottom: '10px', display: 'block', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Correo Electrónico</label>
                            <input
                                type="email"
                                id="email"
                                className="elegant-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="tu@email.com"
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '45px' }}>
                            <label htmlFor="password" style={{ fontWeight: '700', color: 'var(--primary-color)', marginBottom: '10px', display: 'block', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Contraseña</label>
                            <input
                                type="password"
                                id="password"
                                className="elegant-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                            />
                        </div>

                        <button type="submit" className="elegant-btn">
                            Ingresar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
